import { css } from '@emotion/react';
import IconSend16Filled from '~icons/fluent/send-16-filled';
import { theme } from '@arc/frontend/ui-theme';
import { buttonIconAddStyles } from './ButtonIconAdd';
const styles = {
  icon: /*#__PURE__*/css({
    color: theme.colors.palettes.primary.contrastText,
    width: 14,
    height: 14
  }, process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  circle: /*#__PURE__*/css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: theme.colors.palettes.primary.main,
    paddingLeft: 2
  }, process.env.NODE_ENV === "production" ? "" : ";label:circle;")
};
export const buttonSendStyles = styles;
export function ButtonSend(props) {
  return <button type="button" {...props} data-testid="button-send" css={buttonIconAddStyles.addButton}>
			<div css={styles.circle}>
				<IconSend16Filled css={[buttonIconAddStyles.icon, styles.icon, process.env.NODE_ENV === "production" ? "" : ";label:ButtonSend;"]} />
			</div>
		</button>;
}